import React from "react";
import "../../styles/ClaimDetails.scss";
import TextInput from "../text-input/TextInput";
import HelperText from "../helper-text/HelperText";
import TextArea from "../text-area/TextArea";
import DatePicker from "../date-picker/DatePicker";
import ClaimDetailsSchema from "../../schemas/ClaimDetailsSchema";
import GapSelect from "../gap-select/GapSelect";
import Loader from "../loader/Loader";
import RadioInput from "../radio-input/RadioInput";

const ClaimDetails = (props) => {
    const [isLoading, setIsLoading] = React.useState(false);
    const { contractForm } = props;
    const { register, setValue, getValues } = contractForm;
    const { dateOfVehicleLoss, claimDescription, typeOfLoss, odoMeter,question1,question2,question3 } = ClaimDetailsSchema;
    const [descriptionLength, setDescriptionLength] = React.useState(0);
    const [lossTypes, setLossTypes] = React.useState([]);
    const [storedData, setStoredData] = React.useState({});
    const [minDate, setMinDate] = React.useState([]);

    const handleSetValue = (e, key) => {
        //e.preventDefault();
        setValue(key, e.target.value, { shouldValidate: true })
    }

    const getData = async () => {     
        const localStorageData = JSON.parse(localStorage.getItem("tpa_data"));
        if (localStorageData) {
            setStoredData(localStorageData);
            setLossTypes(localStorageData.loss_codes);
            setIsLoading(false);
            setMinDate(localStorage.getItem("sale-date"));
            return;
        }
        setLossTypes([]);
        setIsLoading(false);
        return;
    }

    React.useEffect(() => {
        setIsLoading(true);
        getData();
    }, [])

    return (
        <React.Fragment>
            {isLoading ? <Loader isLoading={isLoading} /> :
                <React.Fragment>
                    <div className="info-heading">Tell Us What Happened</div>
                    <div>
                        <div className="mt-20">
                            <DatePicker
                                id="dateOfVehicleLoss"
                                fieldRegister={register('dateOfVehicleLoss', {
                                    ...dateOfVehicleLoss,
                                    onChange: (e) => { handleSetValue(e, 'dateOfVehicleLoss') }
                                })}
                                errorMessage={contractForm.formState.errors?.dateOfVehicleLoss?.message || null}
                                name="dateOfVehicleLoss"
                                label="Date of vehicle loss"
                                isRequired={true}    
                                minDate={minDate}                        
                            />
                        </div>
                        <div className="mt-20">
                            <GapSelect
                                id="lossType"
                                itemList={lossTypes}
                                name="typeOfLoss"
                                label="What was the cause of loss"
                                value={getValues('typeOfLoss')}
                                isRequired={true}
                                fieldRegister={register('typeOfLoss', {
                                    ...typeOfLoss,
                                    onChange: (e) => { handleSetValue(e, 'typeOfLoss') }
                                })}
                                errorMessage={contractForm.formState.errors?.typeOfLoss?.message || null}
                            />
                        </div>
                        <div className="mt-20">
                            <TextInput
                                name="odoMeter"
                                label="Odometer at time of loss"
                                fieldRegister={register('odoMeter', {
                                    ...odoMeter,
                                    onChange: (e) => { handleSetValue(e, 'odoMeter') }
                                })}
                                errorMessage={contractForm.formState.errors?.odoMeter?.message || null}
                                maxLength={6}
                                isRequired={true}
                            />
                            <HelperText text="If unsure, use an estimation or enter 999999." isShownHelperIcon={false} />
                        </div>
                        
                        {storedData?.question_1 && (
                        <div className="mt-20">
                            <label className="required">{storedData.question_1}</label>
                            <div className="d-flex align-items-center pl-15">
                                <RadioInput
                                    type="radio"
                                    name="question1"
                                    value="Yes"
                                    id="police_report_true"
                                    text="Yes"
                                    fieldRegister={register('question1', {
                                        ...question1,
                                        onChange: (e) => { handleSetValue(e, 'question1') }
                                    })}
                                />                               
                            </div>
                            <div className="d-flex align-items-center pl-15">
                                <RadioInput
                                   type="radio"
                                   name="question1"
                                   value="No"
                                   id="police_report_false"
                                   text="No"
                                   fieldRegister={register('question1', {
                                       ...question1,
                                       onChange: (e) => { handleSetValue(e, 'question1') }
                                   })}                                  
                                />                               
                            </div>
                        </div>
                        )}
                        
                        {storedData?.question_2 && (
                        <div className="mt-20">
                            <label className="required">{storedData.question_2}</label>
                            <div className="d-flex align-items-center pl-15">
                                <RadioInput
                                   type="radio"
                                   name="question2"
                                   value="Yes"
                                   id="personal_use"
                                   text="Yes"
                                   fieldRegister={register('question2', {
                                       ...question2,
                                       onChange: (e) => { handleSetValue(e, 'question2') }
                                   })}
                                />          

                            </div>
                            <div className="d-flex align-items-center pl-15">                               
                                 <RadioInput
                                   type="radio"
                                   name="question2"
                                   value="No"
                                   id="business_use"
                                   text="No"
                                   fieldRegister={register('question2', {
                                       ...question2,
                                       onChange: (e) => { handleSetValue(e, 'question2') }
                                   })}
                                />          
                            </div>
                        </div>
                        )}

                        {storedData?.question_3 && (
                            <div className="mt-20">
                                <label className="required">{storedData.question_3}</label>
                                <div className="d-flex align-items-center pl-15">                                  
                                <RadioInput
                                   type="radio"
                                   name="question3"
                                   value="Yes"
                                   id="question_3_yes_use"
                                   text="Yes"
                                   fieldRegister={register('question3', {
                                       ...question3,
                                       onChange: (e) => { handleSetValue(e, 'question3') }
                                   })}
                                />  
                                </div>
                                <div className="d-flex align-items-center pl-15">                                   
                                <RadioInput
                                   type="radio"
                                   name="question3"
                                   value="No"
                                   id="question_3_no_use"
                                   text="No"
                                   fieldRegister={register('question3', {
                                       ...question3,
                                       onChange: (e) => { handleSetValue(e, 'question3') }
                                   })}
                                  
                                />  
                                </div>
                            </div>
                        )}
                        <div className="mt-20">
                            <TextArea
                                label="Describe what happened"
                                cols={44}
                                rows={10}
                                name="claimDescription"
                                placeholder="in 500 characters or less, explain what happened"
                                fieldRegister={register('claimDescription', {
                                    ...claimDescription,
                                    onChange: (e) => { setDescriptionLength(e.target.value.length); handleSetValue(e, 'claimDescription') }
                                })}
                                errorMessage={contractForm.formState.errors?.claimDescription?.message || null}
                                maxLength={500}
                                isRequired={true}
                            />
                            <span className="claim-description">{descriptionLength}/500</span>
                        </div>
                    </div>
                </React.Fragment>
            }
        </React.Fragment>
    )
};

export default ClaimDetails;